import { Loader2 } from 'lucide-react';
import { statusLabel } from './StageTabs';

export const CompletionBar = ({ status, filled, total, missing, completing, onComplete, milestone }) => (
  <section className="mt-12 rounded-2xl bg-white border border-matte/10 p-6 md:p-8" data-testid="stage-completion">
    {status === 'complete' && milestone && (
      <div className="mb-6 border-l-2 border-gold pl-5 animate-in fade-in duration-700" data-testid="stage-milestone">
        <div className="text-[10px] uppercase tracking-[0.24em] text-gold">Milestone</div>
        <p className="mt-2 font-serif-display text-xl md:text-2xl leading-snug text-matte">{milestone}</p>
      </div>
    )}
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.24em] text-matte/50">Stage status</div>
        <div className="mt-1 font-serif-display text-3xl text-matte" data-testid="stage-status-label">{statusLabel(status)}</div>
        <div className="mt-1 text-sm text-matte/60" data-testid="stage-required-progress">{filled} of {total} required answers completed</div>
      </div>
      <button onClick={onComplete} disabled={completing} className="btn-primary" data-testid="stage-complete-button">
        {completing && <Loader2 size={14} className="animate-spin" />} {status === 'complete' ? 'Save & Keep Complete' : 'Mark Stage Complete'}
      </button>
    </div>
    <div className="mt-4 h-1.5 rounded-full bg-matte/10 overflow-hidden">
      <div className="h-full bg-gold transition-[width] duration-500" style={{ width: `${total ? (filled / total) * 100 : 0}%` }} />
    </div>
    {missing.length > 0 && (
      <div className="mt-5 rounded-xl bg-red-50 border border-red-200 p-4 text-sm" data-testid="stage-missing-list">
        <p className="text-red-800">Almost there. These answers are needed to complete this stage. Your draft is saved.</p>
        <ul className="mt-2 list-disc pl-5 text-red-800/80">{missing.map((m) => <li key={m.key}>{m.label}</li>)}</ul>
      </div>
    )}
  </section>
);
